module.exports = __webpack_public_path__ + "img/icon_1.dddeb8b8.svg";